<template>
  <div @click="selected" class="cursor-pointer p-2" :class="{'bg-indigo-100': isCurrent}">
    <p class="mb-2">
      <b>/{{message.attributes.label}}</b>
      <span class="ml-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
        {{ $t('conversation.whatsappTemplate')}}
      </span>
    </p>
    <p>{{message.attributes.text}}</p>
  </div>
</template>


<script>

export default {
  name: 'WhatsappTemplateMessage',
  props: ['message', 'current'],
  emits: ['template-selected'],
  methods: {
    selected() {
      this.$emit('template-selected', this.message);
    },
  },
  computed: {
    isCurrent() {
      return this.current && this.current.id === this.message.id;
    },
  },
}
</script>
